import { render } from "./instructor-dashboard.vue?vue&type=template&id=09f429a6"
import script from "./instructor-dashboard.vue?vue&type=script&lang=js"
export * from "./instructor-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__